export const DEFAULT_ORIGINAL_LANG_CODE = 'en'
